import React from "react";
import { useParams } from "react-router-dom";
import OrderDetail from "src/pages/orders/[slug]/OrderDetail";

export default function OrderDetailPage() {
  const { id } = useParams();
  return <OrderDetail id={id} />;
}
